// src/App.tsx

import React, { useState, useEffect } from 'react';
import "./styles/Styles.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Page and Component Imports
import ProductsV2 from "./pages/ProductsV2";
import AdminPriceLists from './pages/admin/AdminPriceLists';
import AdminProducts from './pages/admin/AdminProducts';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import CurrencyProvider from './context/RuntimeValuesContext';
import ExchangeRates from './pages/admin/ExchangeRates';
import OrderDetail from './pages/OrderDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProductDetail from './pages/ProductDetail';
import Shipment from './pages/Shipment';
import Support from './pages/Support';
import Us from './pages/Us';
import Chatbot from './components/Chatbot';
import PageViewTracker from './tracking/PageViewTracker';

export type ChatWindowState = 'closed' | 'regular' | 'floating' | 'maximized' | 'minimized';

export function useGlobalValue() {
  const [globalVariable, setGlobalVariable] = useState('USD');
  return { globalVariable, setGlobalVariable };
}

function App() {
  const { globalVariable, setGlobalVariable } = useGlobalValue();
  const [chatState, setChatState] = useState<ChatWindowState>('closed');

  useEffect(() => {
    if (chatState === 'regular') {
      document.body.classList.add('chat-is-docked');
    } else {
      document.body.classList.remove('chat-is-docked');
    }

    return () => {
      document.body.classList.remove('chat-is-docked');
    };
  }, [chatState]);

  return (
    <CurrencyProvider>
      <Router>
        <PageViewTracker />
        <div className="App">
          <Routes>
            <Route path="/" element={<ProductsV2 />} />        
            <Route path="/adminExchange" element={<ExchangeRates />} />
            <Route path="/adminPriceLists" element={<AdminPriceLists />} />
            <Route path="/adminProducts" element={<AdminProducts />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/orderDetail" element={<OrderDetail />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/products" element={<ProductsV2 />} />
            <Route path="/productDetail" element={<ProductDetail />} />
            <Route path="/shipment" element={<Shipment />} />
            <Route path="/support" element={<Support />} />          
            <Route path="/us" element={<Us />} />  
          </Routes>
          
          <Chatbot chatState={chatState} setChatState={setChatState} />
        </div>
      </Router>
    </CurrencyProvider>
  );
}

export default App;